"use strict";
(function (root, f) {
  if (typeof exports === "object") {
    // CommonJS
    module.exports = f();
  } else {
    $KabalaI18n.$extend("en-US", f());
  }
})(this, function () {
  return {
    k: {
      // 按钮
      button: {
        new: "New",
        add: "Add",
        edit: "Modify",
        del: "Delete",
        copy: "Copy",
        move: "Move",
        rename: "Rename",
        select: "Select",
        save: "Save",
        reset: "Reset",
        yes: "Yes",
        no: "No",
        ok: "OK",
        submit: "Submit",
        cancel: "Cancel",
        clear: "Empty",
        close: "Close",
        back: "Back",
        refresh: "Refresh",
        mkfolder: "New folder",
        upload: "Upload",
        update: "Update",
        download: "Download",
        preview: "Preview",
        search: "Search",
        details: "Details",
        permission: "Permission",
        send: "Send",
        export: "Export",
        query: "Query",
        login: "Login",
        moveup: "Move up",
        movedown: "Move down",
        fullscreen: "Full screen display",
        exit_fullscreen: "Exit fullscreen",
        updatepwd: "Modify password",
        showmore: "Show more",
        showless: "Show less",
        helperdownload: "Helper download",
        diff: "compare",
        logout: "Sign out",
      },
      // 选择
      select: {
        file: "Select file",
        folder: "Select folder",
        user: "Select user",
        group: "Select department",
        role: "Select Role",
        template: "Select template",
      },
      // 文字
      text: {
        noData: "no data",
        clearCacheInfo: "Do you want to clear cache?",
        signoutInfo: "Do you want to sign out?",
        changeLanguage: "Change language",
        viewDetail: "View detail",
        fileitems: "items",
        people: "People",
        docs: "Docs",
        message: "Message",
        platform: "Platform",
        my: "My",
        true: "Yes",
        false: "No",
        all: "All",
        none: "None",
        system: "System",
        tag: "tag",
        data: "Data",
        status: "Status",
        nodata: "No data temporarily",
        rootnode: "Root Node",
        location: "Location",
        remark: "Remarks",
        keywords: "Keywords",
        unread: "Unread",
        hasread: "Already read",
        operations: "Operation",
        title: "Title",

        account: "Account",
        accountormobile: "Account or mobile",
        username: "Username",
        password: "Account password",
        user: "User",
        group: "Department",
        role: "Role",
        jobnumber: "Job number",
        jobpost: "Title",
        userscope: "User scope",
        setpassword: "Set password",
        oldpassword: "Old password",
        newpassword: "New password",
        vcode: "Verification code",
        finalpassword: "Confirm password",
        email: "Mailbox",
        phonenumber: "Phone number",
        officephone: "Office phone",
        myaccountinfo: "Personal Information",
        everyone: "Everyone",
        avatar: "Avatar",

        dir: "Dir",
        file: "File",
        image: "Images",
        folder: "Folder",
        name: "Name",
        size: "Size",
        filesize: "File size",
        creator: "Creator",
        version: "Version",
        ctime: "Operation time",
        mtime: "Update time",
        optip: "Operation IP",
        filenameorbody: "Name or content",
        filename: "File name",
        filebody: "File content",
        filetype: "File Type",
        parentdir: "Parent directory",
        spacetype: "belonging to space",
        filedetails: "File details",
        folderdetails: "Folder details",
        opttype: "Operation type",
        operationuser: "Operator",
        operationdesc: "Operation description",

        thumbnail: "Thumbnail",
        list: "List",
        helpinfo: "Help Information",
        mustinput: "Required field",
        systemmanagement: "System management",
        supportbykass: "Support by 上海开始网络科技有限公司",
        baseinfo: "Basic information",
        basedatas: "Basic data",
        notice: "Process notes",
        languagesetting: "Language Settings",
        nowlanguage: "Current language",
        searchresult: "Search Results",
        open: "Open",
        edit: "Modify",
        del: "Delete",
        preview: "Preview",
        download: "Download",
        transpdf: "Export PDF",
        display: "Display",
        display_none: "No display",
        delete_record: "Delete record",
        delete_file: "Delete file",
        openinnewwindow: "New window open",
        selectedmultiple: "{0} selected",
        selected: "Selected",
        moving: "Moving",
        copying: "Copying",
        moreoperations: "More operations",

        countfile: "{0} files",
        countfolder: "{0} folders",

        downloadtips: "Download Tips",
        ask_helperdownload:
          "It is recommended that you use the file assistant to download",

        search: {
          by: {
            all: "Global search",
            fast: "Quick Search",
            name: "Search by name",
          },
        },
        select: {
          multiple: "Multiple choice",
          single: "Single choice",
          dir: "Select directory",
        },
        filediff: "file compare",
        privacy: "Privacy",
        clearCache: "clear cache",
      },
      // 询问(动作类)
      ask: {
        delete: {
          record: "Are you sure you need to delete this record?",
          file: "Are you sure you need to delete the selected document?",
          permission: "Do you want to delete this permission?",
        },
        login: {
          succeed: "Login is successful, do you want to refresh the page?",
        },
        diff: {
          goon: "Do you want to compare them now?",
        },
        text: "You confirm",
      },
      // 提示(动作类)
      tips: {
        // xxx can't
        cannot: {
          // description
          none: {
            mustinput: "{0} cannot be empty",
            name: "Name cannot be empty",
            username: "User name cannot be empty",
            account: "Account cannot be empty",
          },
        },
        // xxx already exists
        exist: {
          name: "Name already exists",
        },
        // xxx does not exist
        notexist: {
          file: "File does not exist",
          details: "The details page does not exist",
          template: "Template does not exist",
        },
        // doing xxx
        ing: {
          export: "Exporting",
          upload: "Uploading",
          initializ: "Initializing",
          save: "Saving",
          calc_file_info: "Calculating file information",
          search: "Searching",
        },
        // success
        succeed: {
          // succeeded in doing xxx
          when: {
            reload: "Reload success",
            rename: "Rename successful",
            new: "Newly created successfully",
            operation: "Operation successful",
            upload: "Upload successful",
            save: "Save successfully",
            mkfolder: "Folder created successfully",
            move: "Move successfully",
            copy: "Move and copy work",
            delete: "Delete successfully",
          },
        },
        // Error message
        error: {
          // do xx action after failure
          please: {
            refresh: "An error occurred, please refresh the page and try again",
          },
          // what failed
          when: {
            rename: "Rename failed",
            new: "New failed",
            upload: "Upload failed",
            download: "Download failed",
            move: "Move failed",
            copy: "Copy failed",
            save: "Save failed",
            delete: "Delete failed",
            search: "Search failed",
            emptypath: "Search in this mode is not supported",
            loginexpired: "Login expired, please log in again",
            template_not_bound: "The template is not bound, please bind first",
            unzip: "Unzip failed",
            zip: "Compression failed",
            loading: "Loading, please try again later",
          },
          versionexist: "file version exist",
          diffconflict:
            "Please select two documents of the same type for comparison",
          notsupport: "not support",
        },
        // please
        please: {
          // enter xxx
          input: {
            password: "Please enter the password",
            oldpassword: "Please enter the old password",
            finalpassword: "Please enter the confirmation password",
            account: "Please enter an account",
            code: "Please enter the verification code",
            phone: "Please enter your phone number",
            words2search: "Enter keyword search",
          },
          // choose
          select: {
            // a xxx
            one: {
              to: "Please select one",
              data: "Please select a data",
              user: "Please select a user",
              file: "Please select a file",
              folder: "Please select a folder",
              userorgroup: "Select a user or group",
              group: "Select a department",
            },
            // more than 1
            gtone: {
              to: "Please select at least one item",
            },
          },
        },
      },

      // 通用组件语言包
      cpt: {
        // 流程
        flow: {
          const: {
            taskopt: {
              approve: "Passed",
              reject: "Reject(stop)",
              restart: "Restart",
              refused: "Refused",
            },
            taskstatus: {
              wait: "Waiting",
              finish: "Finished",
              transfer: "Transferred",
              cancel: "Cancelled",
            },
            flowstatus: {
              turndown: "Rejected",
              runing: "Approval in progress",
              stoped: "Stopped",
              end: "Ended",
            },
            tasktransfer: {
              transfer: "Transfer",
              counterssign: "Add sign",
              cancelcounterssign: "Cancel countersign",
              cc: "CC",
              rollback: "Rollback",
            },
            counterssignrule: {
              all: "Everyone passes and then passes",
              one: "Pass if one person passes",
              frist: "Subject to the first approver",
            },
            nodeusertype: {
              user: "Specified user",
              org: "designated department",
              role: "Specified role",
              form: "Form user",
              launcher: "Launch user",
              leader1: "Promoter first level supervisor",
              leader2: "Promoter second-level supervisor",
              leader3: "Promoter three-level supervisor",
              leader4: "Promoter four-level supervisor",
              leader5: "Promoter five-level supervisor",
            },
          },
        },
        // 标签按钮
        tagbtn: {
          title: {
            when: {
              delete: "Delete prompt",
            },
          },
          ask: {
            when: {
              delete: "Are you sure you need to remove the label of the file?",
            },
          },
        },
        // 用户头像
        userheader: {
          deleted: "Deleted",
        },
        // file icon
        fileicon: {
          lockdesc: "{0} locked on {1}",
        },
        // User selection box
        usertreedialog: {
          search: "Search users, departments",
          result: "Select result",
        },
        // send a text message
        sendsms: {
          smstext: "Get verification code",
          placeholder: "SMS code",
          please_input_code:
            "Please enter the verification code in the picture",
          click_img_refresh: "Can't see clearly? Click the picture to refresh",
          dosendsms: "Send immediately",
          faild_send: "Image verification code generation failed",
          err_phone_format: "Mobile phone number format is incorrect",
          succeed_send: "SMS sent successfully",
        },
        // Assistant program
        kabalahelper: {
          tips: {
            start: "Starting the file assistant, please wait...",
            not_intall: "You did not install the assistant",
          },
          title: {
            check: "Assistant detection",
          },
          text: {
            not_install:
              "The system has detected that you have not installed the file assistant, it is recommended",
            download: "Download Assistant",
          },
        },
        // preview file
        preview: {
          button: {
            spin: "spin",
            shrink: "shrink",
            enlarge: "Enlarge",
            vieworiginal: "View original image",
          },
          tips: {
            ing: {
              preview: "Preparing to preview the file, please wait...",
            },
            when: {
              notsupport:
                "The file type cannot be previewed online (or the file is being converted in the background), it is recommended to open after downloading",
            },
          },
          text: {
            workinggroupdocument: "Workgroup document",
          },
        },
        // 文件详情
        fsdetail: {
          tips: {
            when: {
              emptyshowurl: "The path does not have a detailed display page",
            },
          },
        },
        // total-explorer
        totalexplorer: {
          tips: {
            when: {
              emptypath: "Search in this mode is not supported",
            },
          },
        },
        // totalfiledialog
        totalfiledialog: {
          title: {
            doclibs: "document library",
          },
        },
        // filetreedialog
        filetreedialog: {
          button: {
            uploadfile: "Upload local attachments",
          },
        },
        // space-io
        spaceio: {
          tips: {
            when: {
              cmp: "The cloud is preparing compressed files for you, please wait a moment",
              cmperror: "Compression failed",
              deletesucceedcout: "Successfully deleted {0} nodes",
            },
            ing: {
              count:
                "Statistics of the document information you selected, please wait a moment",
              batexec:
                "Tasks are being executed in batches, please wait a moment",
            },
          },
          ask: {
            when: {
              move: "Are you sure you need to move the selected node to: {0}",
              copy: "Are you sure you need to copy the selected node to: {0}",
            },
          },
          button: {
            move: "Start to move",
            copy: "Start copying",
          },
          title: {
            move: "Move prompt",
            copy: "Copy prompt",
            delete: "Delete prompt",
          },
          text: {
            optcount: "Number of documents for this task: {0}",
            succeedcount: "Operation is over, completed quantity: {0}",
            failedlist: "Failed file list",
          },
        },
        // space-explorer
        spaceexplorer: {
          tips: {
            when: {
              emptypath: "Search in this mode is not supported",
            },
          },
        },
        // space-explorer-datalist
        spaceexplorerdatalist: {
          text: {
            searchstatus: "You are searching globally (name or label)",
          },
        },
        uploader: {
          tips: {
            error: {
              cannotstop: "Cannot stop, a file is calculating information",
              transportfailedcount: "{0} task transmission failed",
            },
            succeed: {
              transportokcount: "{0} tasks have been completed",
            },
          },
          ask: {
            close:
              "Are you sure you need to close and terminate all transfer tasks?",
          },
          button: {
            start: "Start upload",
            append: "Continue to add",
            pause: "Pause upload",
            cancel: "Cancel upload",
          },
          text: {
            hashing: "Trying to send in seconds",
            pause: "Pause",
            wait: "Waiting to upload",
            notask: "No transfer task temporarily",
            transporting: "File transfer",
          },
        },
      },
    },
    pan: {
      button: {
        preview: "Preview",
        download: "Download",
        upload: "Upload",
        new_folder: "New folder",
        downloadzip: "Package Download",
        wpsedit: "Shared Edit",
        helperopen: "Helper open(Read only)",
        helperedit: "Assistant Edit",
        detail: "View Details",
        print: "Print",
        previousnode: "Previous Node",
        addtag: "Add Tag",
        addfilelevel: "File encryption",
        finaldraft: "Final Draft",
        difffiles: "Contrast",
        rversion: "Rollback",
        delete: "Delete",
        add: "Add",
        edit: "Edit",
        save: "Save",
        listsubdir: "List subdirectories",
        listsubfilepms: "List file permissions",
        more: "More",
        add_businessform: "Add Business Form",
        query: "Query",
        export: "Export",
        select: "Select",
        unlockfile: "Unlock",
        lockfile: "Lock",
        sharelink: "Share",
        initiate_teamcollaboration: "Initiate team collaboration",
        unfavorite: "Unfavorite",
        restore: "Restore",
        delete_completely: "completely delete",
        refresh: "Refresh",
        cancel: "Cancel",
        ok: "OK",
        create: "Create",
        update_now: "Update now",
        update: "Update",
        new: "New",
        helper_upload_dir: "Helper upload directory",
        helper_upload_largefile: "Helper upload large file",
        rename: "Rename",
        list_mode: "List mode",
        thumbnail_mode: "Thumbnail Mode",
        start_copying: "Start copying",
        create_cooperation: "Create a collaboration",
        delete_cooperation: "Delete collaboration",
        come_back: "Return to superior",
        unselect_all: "Unselect all",
        select_all: "Select all",
        of_share: "Share of",
        join_editor: "Join editor",
        visit_now: "Visit now",
        acces_official_website: "Visit the official website",
        close: "Close",
        not_download: "Not downloadable",
        send_to_colleague: "Send to colleague",
        external_link: "External link",
        save_to: "Save",
        open_share: "Open sharing",
        unshare: "Unshare",
        copylink: "Copy link",
        unsubscribe: "Unfollow",
        clear: "clear",
        selectuser: "Select user",
        start_statistics: "Start statistics",
        select_dir: "Select directory",
        export_excel: "Export excel",
        select_analysis_file: "Select the file to be analyzed",
        select_analysis_user: "Select the user to be analyzed",
        empty_selected_files: "Empty selected files",
        empty_selected_user: "Empty the selected user",
        export_records: "Export records",
        hide_conditional_area: "Hide conditional area",
        show_condition_area: "Show condition area",
        related_pms_settings: "Related permission settings",
        file_pms_details: "File permission details",
        start_restore: "Start to restore",
        select_resigners: "Select resigners",
        select_handover_user: "Select handover user",
        start_transfer: "Start transfer",
        start_moving: "Start moving",
        move_up: "Move up",
        move_down: "Move down",
        export_secret_doc: "Export the current secret level file",
        see_more: "See more",
        return: "Return",
        view_access_log: "View access log",
        view_his_links: "View history links",
        send_immediately: "Send immediately",
        return_parentdir: "Return to the parent directory",
        export_filelist: "Export file list",
        copy: "Copy",
        reset: "Reset",
        remove: "Remove",
        add_related: "Add Association",
        remove_related: "Unlink",
        related_newv: "Related to the latest version",
        show: "Display",
        hiden: "Hide",
        linkShare:'Link Share',
        wechatShare:"Wechat Share",
        teamShare:'Team Share',
        onlineEdit:'Online Edit',
        viewDetail:'View Detail',
        appShare:'App Share'
      },
      menu: {
        preview: "Preview",
        download: "Download",
        downloadzip: "Package Download",
        helperopen: "Helper open(Read only)",
        helperedit: "Assistant Edit",
        wpsedit: "Shared Edit",
        sharelink: "Share",
        lockfile: "lock",
        unlockfile: "Unlock",
        update: "Upload update",
        zip: "Cloud Compression",
        unzip: "Cloud Unzip",
        copy: "Copy to",
        move: "Move to",
        rename: "Rename",
        delete: "Delete",
        payattention: "Follow",
        cancelpayattention: "Cancel Attention",
        collect: "Collection",
        cancelcollect: "Cancel collection",
        print: "Print",
        transpdf: "Export to PDF",
        detail: "View Details",
        export: "Export",
        company_dir_management: "Company Directory Management",
        dir_manager_setting: "Directory Manager Settings",
        dir_config_detail: "Directory configuration details",
        dir_pms_detail: "Directory Permission Details",
        dir_attention_detail: "Directory attention details",
        lockfile_list: "File Lock List",
        file_tag_class_management: "File Tag Classification Management",
        file_level_management: "File Secret Level Management",
        file_level_setting: "File Secret Level Setting",
        file_level_list: "File Secret Level List",
        add_monitoring_task: "Add sensitive monitoring task",
        company_space_report_analysis: "Company Space Report Analysis",
        file_operation_log: "File Operation Log",
        file_usage_rank: "File Usage Rank",
        user_behavior_analysis: "User Behavior Analysis",
        operation_count: "Statistics of the number of operations",
        incremental_trend_graph: "Incremental Trend Graph",
        update_trend_graph: "Update Trend Graph",
        delete_trend_graph: "Delete Trend Graph",
        external_link_access_log: "External link access log",
        dir_structure_export: "Directory structure export",
        pms_setting_list: "Permission Setting List",
        user_pms_list: "User Permission List",
        personal_space_management: "Personal Space Management",
        usage_statistics: "Usage Statistics",
        file_type_statistics: "File Type Statistics",
        personal_space_allowance: "personal space allowance",
        team_space_management: "Team Space Management",
        recycle_bin_management: "Recycle Bin Management",
        company_doc_recycle_bin: "Company Document Recycle Bin",
        resignation_data_transfer: "Resignation Data Transfer",
      },
      title: {
        file_detail: "File Details",
        dir_detail: "Folder Details",
        select_filetag: "Select file tag",
        edit_diradmin: "Modify the directory administrator",
        add_diradmin: "Add directory administrator",
        confirm_delet: "Confirm to delete",
        select_form: "Select form",
        setup_pms: "Set permissions",
        addfilter: "Add filter conditions",
        modify_space_allowance: "Modify space allowance",
        add_space_allowance: "Add space allowance",
        add_attention: "Add attention",
        update: "Upload update",
        zip: "Cloud Compression",
        new_file: "New File",
        confirm_operation: "Confirm Operation",
        doc_dir: "Document Directory",
        copy_tips: "Copy Tips",
        move_tips: "Move tips",
        delete_tips: "Delete tips",
        lockfile_tips: "Lock tips",
        business_form: "Business form",
        create_tag: "Create tag",
        filetag: "File tag",
        set_password: "Set password",
        delete_cooperation: "Delete collaboration",
        cooperation: "collaboration",
        cooperation_detail: "Team collaboration details",
        create_cooperation_space: "Create a team collaboration space",
        teamdoc: "Team Document",
        KassCloud: "Start Cloud Disk",
        start_shared_editing: "Start shared editing",
        tips_info: "Prompt info",
        access_err: "Access error",
        share_detail: "Share details",
        company_dir_config_detail: "Company directory configuration details",
        pms_setting_details: "Permission setting details",
        pms_setting_logs: "Permission setting log",
        user_pms_query: "User permission query",
        pmslist: "Permission list",
        restore_tips: "Restore Tips",
        modify_sensitive_monitoring_tasks: "Modify sensitive monitoring tasks",
        add_sensitive_monitoring_tasks: "Add sensitive monitoring tasks",
        modify_file_level: "Modify file secret level",
        add_file_level: "Add file level",
        modify_tag_group: "Modify tag group",
        add_tag_group: "Add tag group",
        modify_tag: "Modify tag",
        add_tag: "Add tag",
        share_link_access_log: "Share link access log",
        sharelink: "Share",
        related_detail: "Related Details",
      },
      tips: {
        ziping:
          "The cloud is preparing compressed files for you, please wait...",
        pdfing:
          "The cloud is preparing to generate PDF files for you, please wait...",
        printing: "Printing, please wait...",
        download_fail: "Download failed",
        dir_is_empty: "The target file is an empty folder",
        zip_fail: "Compression failed",
        select_a_file: "Please select a file",
        confirm_jump:
          "Are you sure to leave the details interface and jump to the current path?",
        ask_delete: "Are you sure you want to delete?",
        ask_delete_selectedfile:
          "Are you sure you need to delete the selected file?",
        ask_lock_selectedfile:
          "Are you sure you need to lock the selected file?",
        ask_unsubscribe_selectedfolder:
          "Are you sure you need to unfollow the selected folder?",
        ask_delete_completely_selectedfile:
          "Are you sure you need to completely delete the selected file?",
        ask_delete_selectedtag:
          "Are you sure you need to delete the selected tag?",
        ask_delete_selected_filelevel:
          "Are you sure you need to delete the selected security level?",
        ask_delete_tag: "Are you sure you want to delete this tag?",
        ask_delete_filelevel: "Are you sure you want to delete this level?",
        ask_delete_selectedpms:
          "Are you sure you need to delete the selected permissions?",
        ask_delete_config:
          "Are you sure you need to delete the selected configuration?",
        ask_delete_level: "Are you sure you want to delete this level?",
        ask_delete_selectedtask:
          "Are you sure you need to delete the selected task?",
        filetag_add_success: "File tag added successfully",
        filetag_add_failed: "File tag addition failed",
        filetag_remove_success: "File tag removed successfully",
        filetag_remove_failed: "File tag removal failed",
        this_level_existed: "The secret level already exists",
        filelevel_add_success: "File secret level is set successfully",
        filelevel_add_failed: "File level setting failed",
        filelevel_remove_success: "File level removal succeeded",
        filelevel_remove_fail: "File level removal failed",
        no_preview_pms: "You do not have permission to preview",
        success_operation: "Operation successful",
        operation_failed: "Operation failed",
        select_at_least_one: "Please select at least one item to operate",
        select_one: "Please select one to operate",
        delete_success: "Delete successfully",
        delete_failed: "Delete failed",
        save_success: "Save successfully",
        save_fail: "Save failed",
        ask_delete_businessform: "Are you sure to delete this business form?",
        select_one_businessform: "Please select a business form",
        pms_denied: "You do not have permission",
        no_more_data: "No more data",
        chart_loading_failed: "Chart loading failed",
        size_must_be_a_number: "The size of the limit must be a number",
        operation_type_cannot_be_empty: "The operation type cannot be empty",
        no_log_info_found: "No log information found",
        path_cannot_be_jumped: "The path cannot be jumped",
        unfollow_successfully: "Unfollow successfully",
        unfollow_failed: "Unfollow failed",
        followed: "Follow success",
        follow_failed: "Following failed",
        cannot_move_to_the_root_dir:
          "Cannot copy to the root directory of the collaboration area",
        file_moved_successfully: "File moved successfully",
        file_move_failed: "File move failed",
        file_copied_successfully: "File copied successfully",
        copy_successfully: "Copy successful",
        successfully_deleted: "Successfully deleted",
        nodes: "nodes",
        lock_failed: "Lock failed",
        locked_successfully: "Locked successfully",
        unlock_failed: "Unlock failed",
        unlock_successfully: "Unlock successfully",
        collection_success: "Collection success",
        collection_failed: "Collection failed",
        unfavorite_successfully: "Unfavorite successfully",
        failed_to_unfavorite: "Unfavorite failed",
        cancelling_collection: "Cancelling collection",
        cancelling_attention: "Cancelling attention",
        etc: "etc",
        files: "Files",
        folders: "Folders",
        tags: "Tags",
        enter_name_for_zipfile:
          "Please fill in the name of the compressed file",
        select_path: "Please select the path",
        select_the_file_to_compressed:
          "Please select the file to be compressed",
        compressed_successfully: "Compressed successfully",
        compression_failed: "Compression failed",
        enter_unzip_dir: "Please fill in the directory of the extracted file",
        select_unzip_path: "Please select the unzip path",
        unzip_dir_already_exists:
          "The current path already exists, please change the name of the unzipped folder",
        successfully_decompressed: "Decompression successful",
        unzip_failed: "Unzip failed",
        ask_edit_now: "The file has been created, do you want to edit it now? ",
        parent_path_does_not_exist: "The parent path does not exist",
        enter_filename: "Please fill in the file name",
        unsupported_file_type: "Unsupported file type",
        name_already_exists: "Name already exists",
        name_already_exists_try: "Already exists, please try another name",
        switch_binding_state_tips:
          "Switching the binding state may cause the upload component to not be bound to the event",
        ask_copy_to: "Are you sure you need to copy the selected node to",
        ask_move_to: "Are you sure you need to move the selected node to",
        search_is_not_supported_in_this_mode:
          "Search in this mode is not supported",
        folder_created_successfully: "The folder was created successfully",
        renamed_successfully: "Renamed successfully",
        renamed_failed: "Rename failed",
        tagname_is_missing: "The tag name is not filled in",
        tags_deleted_successfully: "Tag deleted successfully",
        filelevel_tips:
          "Some operations will be prohibited when the file belongs to the file level",
        inconsistent_pwds: "The two entered passwords are inconsistent",
        enter_sms_verification_code: "Please enter SMS verification code",
        enter_old_pwd: "Please enter the old password",
        pwd_setting_successfully: "Password setting is successful",
        pwd_setting_failed: "Password setting failed",
        avatar_updated_successfully: "Avatar updated successfully",
        avatar_updated_failed: "avatar update failed",
        least_one_department: "The user belongs to at least one department",
        uname_cannot_be_empty: "User name cannot be empty",
        modify_title_failed: "Failed to modify title",
        modify_partuser_failed: "Failed to modify the participant",
        modify_closeday_failed: "Failed to modify the deadline",
        ask_delete_collaboration: "Are you sure to delete this collaboration?",
        delete_cooperation_successfully: "Delete cooperation successfully",
        ask_delete_cooperation_space:
          "The file will not be visible after the collaboration space is deleted. Are you sure you need to delete it?",
        enter_cooperation_space_name:
          "Please enter the name of the collaboration space",
        select_collaborator:
          "Please select a person to participate in the collaboration",
        select_cooperation_endtime:
          "Please select the expected end time of this collaboration.",
        folder_empty: "The folder is empty.",
        upload_successfully: "Upload successful",
        upload_failed: "Upload failed",
        start_upload: "Start upload",
        cannot_previewed: "File cannot be previewed",
        uname_required: "Username is required to identify you when editing",
        sharelink_not_exist: "Share link does not exist or has been cancelled",
        sharelink_not_accessible: "Share link is not accessible",
        sms_sent_successfully: "SMS sent successfully, please check it",
        sms_sent_failed: "Failed to send SMS",
        enter_phone_number: "Please enter your phone number",
        pwd_verification_failed: "Password verification failed",
        remove_share_successfully: "Remove share successfully",
        remove_share_failed: "Remove share failed",
        only_select_single_sharelink_to_copy:
          "Only select a single share link to copy",
        link_and_pwd_join_clipboard:
          "The link and password have been placed on the clipboard",
        link_join_clipboard: "The link has been placed on the clipboard",
        share_does_not_exist: "Share does not exist",
        dirrange_not_selected: "The folder range is not selected",
        diradmin_unfilled: "The directory administrator has not filled in",
        licensablerange_unfilled: "The licensable range is not selected",
        licensabletype_not_selected: "licensabletype not selected",
        deleting_ploy: "Deleting {0} strategies",
        deleting_task: "Deleting {0} tasks",
        deleting_tag: "Deleting {0} tags",
        successfully_delete_nodes: "Successfully deleted {0} nodes",
        diradmin_saved_successfully_but_auth_failed:
          "The directory administrator saved successfully but failed to grant the user permission",
        file_does_not_exist: "File does not exist",
        select_user: "Please select a user",
        no_data_has_been_found: "No data found",
        no_pms_info_found: "No permission information found",
        select_analysis_file: "Please select the file to be analyzed",
        select_analysis_operationtype:
          "Please select the type of operation that needs to be analyzed",
        select_statistical_dir_range:
          "Please select the statistical directory range",
        select_statistical_user_range:
          "Please select the statistical user range",
        ask_restore_to:
          "Are you sure you need to restore the selected node to:",
        successful_migration: "Migration successful",
        data_loading_failed: "Data loading failed",
        tag_status_color_not_selected: "Tag status color not selected",
        prohibited_operation_type_not_selected:
          "Prohibited operation type not selected",
        jumping_please_wait: "Jumping, please wait",
        select_authorized_range:
          "Please select the user range that needs to be authorized",
        ask_unshare: "Are you sure you need to cancel the sharing link?",
        file_sent_successfully: "File sent successfully",
        link_generated_successfully: "Link generated successfully",
        enter_access_pwd: "Please enter the access password",
        watermark_savepdftext_prompt:
          "The length of the watermark text cannot be greater than 100 when exporting PDF",
        watermark_previewtext_prompt:
          "The length of the watermark text cannot be greater than 100 when previewing the file",
        rootdir_reached: "Root directory has been reached",
        select_authorized_pms:
          "Please select the permissions that need to be granted",
        select_pms_setupuser: "Please select the permission setter",
        select_pms_owner: "Please select the permission owner",
        no_pms: "Permission restricted",
        major_version_is_empty: "The major version is empty",
        minor_version_is_empty: "Minor version is empty",
        get_version_number_failed: "Get version number failed",
        edition_setting_failed: "Edition setting failed",
        attr_rule_has_been_deleted: "The attribute rule has been deleted",
        removal_failed: "Removal failed",
        removed_successfully: "Removed successfully",
        no_major_version_selected: "No major version selected",
        no_minor_version_selected: "No minor version selected",
        please_fill_attr: "Please fill in the attributes",
        please_select_the_attr_to_be_added:
          "Please select the attribute to be added",
        confirm_jump_detial:
          "Are you sure to jump to the detail page of this file?",
        enter_version_desc: "Please enter a version description",
      },
      text: {
        file: "File",
        dir: "Directory",
        folder: "Folder",
        current_position: "Current position",
        path: "Path",
        tag: "tag",
        system: "System",
        docspace: "Document area",
        tenantdoc: "Company documents",
        teamdoc: "Team Document",
        basicattr: "Basic attributes",
        fileversion: "Version record",
        filelogs: "Operation log",
        filemeta: "Business Form",
        filelinkcharts: "Related files",
        tenantdoccfg: "File Folder Policy",
        pmsmanagement: "Permission Management",
        diradmins: "Directory administrators",
        dirrecycle: "Recycle Bin",
        dirlogs: "File operation log",
        tenantdoccfgs: "Subfolder Policy List",
        watermarkcfg: "Watermark strategy",
        basicinfo: "Basic information",
        filename: "File name",
        dirname: "Folder name",
        currentversion: "Current version",
        currentoperating: "File operation",
        cuser: "Creator",
        fileposition: "File position",
        dirposition: "Folder location",
        dirpath: "Folder path",
        size: "Size",
        filesize: "File size",
        dirsize: "Folder size",
        ctime: "Created time",
        vuser: "Editor",
        space: "Space",
        vtime: "Modification time",
        revisiontime: "Revision time",
        filepms: "File permissions",
        lock: "locked",
        lockinfo: "Lock information",
        filetag: "File tag",
        filelevel: "File Secret Level",
        businessfeature: "Business Features",
        teaminfo: "Team Information",
        launcher: "Launcher",
        partuser: "Participant",
        setupuser: "Setup person",
        start_date: "Start date",
        end_date: "End time",
        createtime: "Initiation time",
        createday: "Initiation date",
        closetime: "Deadline time",
        closeday: "Deadline date",
        smartsummary: "Smart Summary",
        smarttags: "Smart tags",
        same_content_file: "Same content file",
        askviewurl: "Preview file",
        askdownload: "Download file",
        newfile: "Upload file",
        updatefile: "Update file",
        delfile: "Delete file",
        deldir: "Delete folder",
        mkdir: "Create folder",
        rendir: "Rename folder",
        renfile: "Rename file",
        move: "Move file",
        on: "on",
        diradmin: "Folder Administrator",
        pmslist: "Permission list",
        version: "Version",
        filemd5: "File MD5",
        operator: "Operator",
        operationtype: "Operation Type",
        operationparam: "Operation parameters",
        operationip: "Operation IP",
        operationtime: "Operation time",
        dirrange: "Folder range",
        select_one_user: "Select a user",
        select_one_or_more_groups: "Select one or more groups",
        select: "Select",
        issued_diradmin: "issued directory administrator",
        not_allowed: "Not allowed",
        allow: "Allow",
        allow_size: "Allow size",
        actual_size: "Actual size",
        licensablerange: "Licensable range",
        licensabletype: "licensable type",
        allow_to_issue: "Allow to issue",
        yes: "Yes",
        no: "No",
        settime: "Set time",
        expiredate: "Expiration date",
        showall: "show all",
        no_graphics_data: "No graphics data yet",
        change_batch: "click to change batch",
        currentdir: "Current folder",
        system_supports_watermark_type: "System supports watermark type",
        insert_watermark_info_when_exporting:
          "Automatically insert watermark information when exporting PDF",
        insert_user_info_when_exporting:
          "Automatically insert user information when exporting PDF",
        watermark_on_exporting_enter:
          "Use user input watermark information when exporting PDF",
        insert_watermark_info_during_preview:
          "Automatically insert watermark information when previewing the file",
        insert_user_info_during_preview:
          "Automatically insert user information when previewing files",
        space_quota_strategy: "Space Quota Strategy",
        quota_global_placeholder: "The unit is MB",
        quota_placeholder: "The unit is MB, empty means unlimited",
        upload_file_type_strategy: "Upload file type strategy",
        versionup: "Version update strategy",
        allow_upload_file_types: "allow upload file types",
        prohibited_uploading_file_types: "Prohibited uploading file types",
        fillin_suffix_placeholder:
          "Fill in the file suffix name, multiple separated by English commas. For example: ppt,pptx,pdf",
        rolling_major_version: "rolling major version",
        rolling_minor_version: "rolling minor version",
        versionup_caption:
          "Rolling major version, which means that the major version number will be rolled when updating the file; Rolling minor version, which means that the minor version number will be rolled by default when updating the file; if the previous version is the final version, the major version number will be forced to roll when the file is updated .",
        authorized_user: "authorized user",
        specify_user_range: "Specify user range",
        user_range: "User Range",
        pmstypes: "Permission type",
        pms_policy: "Permission Policy",
        view: "View",
        not: "None",
        deleting: "Deleting",
        item: "Item",
        select_user_or_user_range: "Select user or user range",
        starttime: "Start date",
        endtime: "End date",
        name: "Name",
        selectdir: "Select folder",
        enable_minor_version: "Enable minor version",
        enable: "Enable",
        disable: "Disable",
        unlimited: "Unlimited",
        allowed_types: "Allowed types",
        taboo_types: "Forbidden types",
        search_by_name: "Search by name...",
        search_by_admin: "Search by administrator...",
        search_by_user: "Search by user...",
        admin_can_perform_operations:
          "executable folder policy, permission management, recycle bin and other directory management operations",
        businessform_help1:
          "The current file has no business form data and the user does not have permission to add business forms",
        businessform_help2:
          "The business form needs to be created in the background [Business Center]->[Form Configuration]",
        locktime: "lock time",
        statistics_in_progress:
          "Statistics of the document information you selected, please wait...",
        calculating: "Calculating...",
        number_of_documents_for_this_task: "Number of documents for this task",
        task_is_being_executed_in_batch:
          "Tasks are being executed in batches, please wait...",
        the_doc_selected_s_being_copied:
          "The document you selected is being copied, please wait...",
        moving: "Moving...",
        copying: "Copying...",
        quantity_completed: "Operation completed, quantity completed",
        failed_file: "Failed file",
        delete: "Delete",
        personal_recycle_bin: "Personal Recycle Bin",
        delete_time: "Delete time",
        target_path: "Target path",
        zipfilename: "Compressed file name",
        enter_compressed_filename: "Please enter the compressed file name",
        zip_tips:
          "Cloud compression supports 1G size and no more than 500 files",
        unzipfilename: "Unzip folder name",
        enter_unzipped_filedir: "Please enter the unzipped file directory",
        unzip_tips: "Online decompression supports files up to 1G in size",
        new: "New",
        owned_dir: "owned directory",
        click_or_drag: "click or drag",
        type: "Type",
        perform_update: "Perform update",
        file_search: "File search",
        dir_search: "Folder search",
        meta_search: "Extended attr search",
        name_filtering: "Name Filtering",
        file_or_folder_name: "File or folder name",
        file_or_folder: "File or folder",
        search_by_file_name: "Search by file name...",
        search_by_folder_name: "Search by folder name...",
        first_level_file_filtering: "First level file filtering...",
        new_folder: "New folder",
        loading: "Data loading....",
        no_data: "No data temporarily",
        search_tags: "Search tags",
        select_result: "Select result",
        current_tags_group: "Current tag group",
        tags_group: "tag group",
        tagname: "Tag name",
        enter_tag_name: "Please enter the tag name",
        currently_no_tags: "Currently no tags",
        personal_center: "Personal Center",
        personal_info: "Personal Information",
        change_password: "Modify password",
        send_messagees: "Send SMS",
        login_phonenumber: "Login phone number",
        security_verification_method: "Security verification method",
        old_password: "Old password",
        verification_code: "Verification code",
        enter_the_old_pwd: "Please enter the old password",
        sms_code: "SMS code",
        login_pwd: "Login password",
        enter_the_pwd: "Please enter the password",
        confirm_pwd: "Confirm password",
        click_to_select_the_picture_to_update:
          "Click to select the picture to update",
        login_account: "Login account",
        actual_name: "Name",
        enter_actual_name: "Please enter the user's real name",
        email: "Email",
        enter_email:
          "Please enter an email address, which can be used to receive information",
        phone_number: "Phone number",
        enter_phone_number: "Please enter your phone number",
        office_phone: "Office Phone",
        enter_office_phone: "Please enter the phone number",
        department: "Department",
        role: "Role",
        user: "User",
        job_number: "Job number",
        position: "Position",
        remarks: "Remarks",
        cooperation_list: "collaboration list",
        my_initiated: "I initiated it",
        my_participated: "I participated",
        collaboration_title: "Collaboration Title",
        all_day: "all day",
        collaboration_desc: "Collaboration space description",
        tips: "tip",
        collaboration_tips:
          "The right side is the storage location of the collaboration content space. You can initialize some documents or click upload to select documents in any location.",
        uname: "Username",
        enter_nickname_or_realname:
          "It can be a nickname or real name, so that you can be identified when editing",
        action: "Action",
        this_share_requires_pwd_verification:
          "This share requires password verification",
        password: "Password",
        link_has_expired_contact_sender:
          "This link has expired, please contact the sender",
        link_maybe_invalid: "The link may be invalid",
        filename_sendnote_sendersearch: "File name, send note, sender search",
        sharer: "Sharer",
        receiver: "Receiver",
        locker: "Lock the person",
        deleter: "Delete person",
        share_pms: "Sharing permissions",
        share_notes: "Share notes",
        share_time: "Share time",
        expiration_time: "Expiration time",
        permanent_validity: "Permanent valid",
        expires_after_7_days: "Expires after 7 days",
        expires_after_30_days: "Expires after 30 days",
        expired: "Expired",
        access_password: "Access password",
        shared_file_with_you: "Shared the file with you",
        use_pwd_authentication: "Use password authentication",
        filename_sendnote_search: "File name, send note search",
        pwd_filename_search: "Access password, file name search",
        sendnote: "Send notes",
        no_sharing: "No sharing",
        link: "Link",
        no_notes: "No notes",
        attention_type: "Attention Type",
        attention_time: "Attention time",
        after_uploading_the_file: "After uploading the file",
        after_updating_the_file: "After updating the file",
        after_renaming_the_file: "After renaming the file",
        after_moving_the_file: "After moving the file",
        after_downloading_the_file: "After downloading the file",
        after_deleting_the_file: "After deleting the file",
        followers: "Follow people",
        page_not_found: "The page you want was not found",
        select_one_folder: "Select a folder",
        max_space_limit: "Maximum space limit",
        max_limit: "Maximum limit",
        unit_is_mb_no_limit_if_blank:
          "The unit is MB, if you don't fill it, there will be no limit",
        file_types_stored: "File type stored",
        allowed_file_types: "Allowed file types",
        prohibited_file_types: "Prohibited file types",
        operation_desc: "Operation description",
        file_creator: "File creator",
        pms_number: "Number of permission entries",
        statistics_view: "Statistics view",
        daily_statistics: "Statistics by day",
        weekly_statistics: "Statistics by week",
        monthly_statistics: "Monthly statistics",
        start_time_range: "Start time range",
        end_time_range: "End time range",
        select_dir_to_export_filelist:
          "Select a directory to export a list of all files in that directory",
        file_only: "File only",
        folder_only: "Folder only",
        files_and_folders: "Files and folders",
        filelist_to_be_analysis: "List of files to be analyzed...",
        earliest_operation_date: "Early operation date",
        latest_operation_date: "Early operation date",
        operations_total: "Total number of operations",
        external_link_creator: "File external link creator",
        operating_equipment: "Operating equipment",
        most_statistics_tips:
          "Up to 100 popular files are counted, and the popular file statistics method is calculated according to the frequency of file use.",
        author: "Author",
        uses_total: "Total number of uses",
        related_pms_settings: "Related permission settings",
        file_pms_details: "File permission details",
        export_select_dir_pmslist_tips:
          "Export the user's permission setting list on the subfolders of the selected folder, the export field contains (columns): associated user, permission path, permission type, permission policy, permission scope, setting person, setting time",
        export_select_all_dir_pmslist_tips:
          "Export the user's permission information on all subfolders and files of the selected folder, the export field contains (columns): file|folder path, associated user, permission type (calculation result), permission source path",
        global_config: "Global Configuration",
        user_config: "User Configuration",
        modify_user_space_quota: "Modify user space quota",
        add_user_space_quota: "Add user space quota",
        file_type_distribution_by_size: "File type distribution (by size)",
        file_type_distribution_by_number: "File type distribution (by number)",
        personal_space_usage: "Personal space usage",
        used_size: "Used size",
        remaining_space: "Remaining space",
        docspace_size: "Document area size (used proportion)",
        dirrecycle_size: "Recycle bin size (used proportion)",
        select_type_of_data_transfer: "Please select the type of data transfer",
        transfer_dir_manager: "transfer directory manager",
        transfer_dir_manager_desc:
          "Transfer the directory administrator permissions of the leaving user to the target user",
        copy_personal_doc: "Copy personal documents",
        copy_personal_doc_desc:
          "Copy the personal document of the departing user to the personal document of the target user",
        transfer_user_pms: "Transfer user permissions",
        transfer_user_pms_desc:
          "Transfer the user permissions of the departing user to the target user",
        transfer_user_share: "Transfer sharing record",
        transfer_user_share_desc:
          "Transfer the originator of the share to the target user",
        transfer_team_launcher: "transfer team initiator",
        transfer_team_launcher_desc:
          "Transfer the initiator of the team document to the target user",
        task_name: "Task name",
        auto_encryption: "Automatic encryption",
        execution_scope: "Execution scope",
        notice_object: "Notice object",
        task_conditions: "Task conditions",
        content: "Content",
        md5: "MD5",
        multiple_val_are_separate_by_commas:
          "Multiple values are separated by English commas",
        sort: "sort",
        file_level_name: "File level name",
        file_level_color: "File secret level color",
        prohibited_operation_type: "Prohibited operation type",
        tag_group_admin: "Tag group administrator",
        tag_group_admin_list: "Tag group administrator list",
        team_name: "Team name",
        files_number: "Number of files",
        max_space_single_team: "Maximum space for a single team",
        sys_recommendation: "System Recommendation",
        recommend_recent_desc:
          "Recommendation given to you based on recent operations",
        popular_company_doc: "Popular company documents",
        recommend_count_recent_desc:
          "Recommendation given to you based on the number of operations performed on the company document",
        my_collection: "My Collection",
        collection_n: "Total collection files: {0}",
        no_favorite_files: "You have no favorite files",
        work_info: "Work info",
        share_with_me: "Share with me",
        description: "Description",
        permission: "Permission",
        share_date: "Date",
        teamwork_in_progress: "Teamwork in progress",
        etc_files: "etc {0} files",
        no_upload_files: "No upload files yet",
        recent_actions: "Recent actions",
        create_the_file: "Create the file",
        no_doc_summary_info: "No document summary info",
        unknown_file_name: "Unknown file name",
        day: "day",
        permanent: "Permanent",
        preview_and_ownload: "Preview download",
        preview_only: "Preview only",
        send_to_colleague: "Send to colleague",
        external_link: "External link",
        save_to: "Save as",
        pwd_access: "Password access",
        anonymous_access: "Anonymous access",
        send_to_number: "Sent to {0} people",
        corporate_doc_growth_trends: "Company document growth trends",
        uploaded_file_number: "Number of uploaded files",
        pms_location: "Permission location",
        all_pms: "All permissions",
        only_name_visible: "Only the name is visible",
        hide_it: "Hide it",
        collaboration_schedule: "collaboration schedule",
        finished: "completed",
        processing: "In progress",
        scan_with_phone:
          "Scan with your mobile phone (click to download the QR code)",
        shareedit: "shared edit",
        access: "Access",
        access_ip: "Access IP",
        access_device: "Access device",
        access_homepage: "Access homepage",
        does_not_exist: "does not exist",
        no_recipient_selected_yet: "You have not selected the recipient",
        file_link: "File link",
        expire_after_days: "Expires after days",
        choose_custom_period: "Choose a custom period",
        custom_period: "Custom period",
        sharing_period: "Sharing period",
        preview: "Preview",
        download: "Download",
        modify_setting: "Modify Settings",
        sharing_setting: "Sharing Settings",
        share_user: "Share User",
        share_content: "Share Content",
        say_something: "Say something",
        copy_link_and_pwd: "Copy link and password",
        create_new_link: "Create a new link",
        address: "Access Address",
        max_number_visits: "Maximum Number of Visits",
        blank_means_unlimited:
          "If you don't fill in, it means unlimited. If you need to limit, please enter the number of times (integer value)",
        with_pwd: "has a password",
        no_pwd: "No password",
        blank_unlimited: "If you don't fill in, it means no time limit",
        never_expire: "Never expire",
        setpms_expire_tips:
          "After setting the expiration time, the permissions will be automatically deleted after expiration!",
        extended_attr: "Extended Attributes",
        team_space_size: "Team space size",
        status: "Status",
        set_edition: "Set Edition",
        current_edition: "Current Edition",
        required_attr_tips:
          "The required attributes are not filled in, please click set attributes to continue",
        inherit_superior_pms: "Inherit superior permissions",
        list_superior_pms: "List superior permissions",
        effective: "Effective",
        invalid: "Invalid",
        reset_attr: "Reset attributes",
        select_attr: "Select attribute",
        attr_name: "Attribute Name",
        attr_value: "attribute value",
        edit_edition: "Edit Edition",
        version_number: "Version number",
        parent_directory: "Parent Directory",
        attr: "Attribute",
        userpms_help_desc:
          "The range of granted users will be visible in the file space shared with me",
        no_extended_attr: "No extended attributes",
        related: "Related",
        current: "Current",
        reverse_related: "Reverse related",
        file_related: "File Related",
        version_desc: "Version description",
        attention_help:
          "After adding attention to the folder, a system message will be sent to notify you after the files in the folder are changed.",
        inheritance_pms: "Inherited permissions",
        local_pms: "Local permissions",
        pms_source: "Permission source",
        input_watermark: "Input watermark info",
        watermark_txt: "Watermark text",
        showuser: "display operator",
        showdate: "display time",
      },
      pms: {
        visabled: "Visible name",
        preview: "Preview file",
        print: "Print file",
        transpdf: "Export PDF",
        share: "Share file",
        dwonload: "Download file",
        newfile: "New file",
        newdir: "New folder",
        modify: "Modify file",
        rename: "Rename",
        delete: "Delete file",
        deletedir: "Delete folder",
        setmeta: "Set attributes",
        visabledhistory: "History version is visible",
        rollbackversion: "version rollback",
        deleteversion: "Version delete",
        recycled: "Recycle Bin Management",
        viewlog: "Log query",
        settag: "File secret",
        finallversion: "Final version", //removed
      },
    },
    im: {
      text: {
        sendCloudFile: "Send cloud file",
        sendLocalFile: "Send local file",
        quit_group: "Do you want to quit the group?",
        del_group: "Do you want to delete the group?",
        enter_groupName: "enter group name",
        groupName: "Group name",
        imwellcome:
          "You can start user chat channels, group chat channels and your fixed department channels here",
        searchcontacts: "Search contacts",
        group: "Group",
        news: "News",
        startchat: "Start a chat",
        chatchannel: "Chat channel",
        organization: "Organizational Structure",
        groupdetails: "Group details",
        create: "Create",
        groupmembers: "Group members",
        // The following is from Brother Zhonghua XX
        disband_group_chat: "Disband group chat",
        leave_group_chat: "Leave group chat",
        department_members: "Department members",
        member_removed_successfully: "Member removed successfully",
        compression_failed: "Compression failed",
        folder_not_support_preview: "The folder does not support preview",
        chat_record: "Chat record",
        collect: "Collection",
        forward: "Forward",
        withdraw: "Withdraw",
        edit_group_name: "Edit group name",
        chat_file: "Chat file",
        chat_images: "Chat images",
        add_members: "Add members",
        member_information: "Member Information",
        send_cloud_documents: "Send cloud documents",
        send_pictures: "Send pictures",
        send_local_attachments: "Send local attachments",
        you_withdrew_message: "You withdrew a message",
        withdrew_message: "A message was withdrawn",
        forwarded_successfully: "forwarded successfully",
        forward_failed: "Forwarding failed",
        collection_success: "Collection success",
        collection_failed: "Collection failed",
        withdrawal_failed: "Withdrawal failed",
        message_failed_send: "Message sending failed",
        application_news: "Application News",
        attachment_may_no_exist: "The attachment may no longer exist",
        send_prompt: "Enter to send",
        send_line_break_prompt: "Enter to send, Alt+Enter to wrap",
        search_users: "Search users",
        rollingload: "Rolling load",
        groupSettings: "Channel settings",
      },
      ask: {
        when: {
          exitgroup: "Are you sure need to exit this group?",
          disbandgroup: "Are you sure need to disband this group?",
        },
      },
      tips: {
        error: {
          when: {
            newchart: "New chat failed",
            exitgroup: "Failed to exit the group",
            disbandedgroup: "Failed to disband the group",
            bookmarktypenosupper: "cannot bookmark this type of message",
          },
        },
        succeed: {
          when: {
            exitgroup: "Group exit successfully",
            disbandedgroup: "Group disbanded successfully",
          },
        },
        ing: {
          when: {
            compressingfiles:
              "The cloud is preparing compressed files for you, please wait a moment",
          },
        },
      },
    },
    platform:{
      newflow:'Newflow',
      workflow:'Workflow',
      launchAndUnfinished:'launch And Unfinished',
      attendedAndUnfinished:'Attended And Unfinished',
      attendedAndEnded:'Attended And Ended',
      myTodo:'My todo',
      launchByMe:'Launch By Me',
    },
    doc:{
      enterName:'Enter Name',
      confirmDel:'Delete the file(s)?',
      enterFolderName:'Enter folder name',
      enter:'Enter',
      name: 'name',
      selected:'Selected',
      item:'item(s)'
    }
  };
});
